import EfLink from '@elem/ui/ef-link';
import { useRouter } from 'next/router';
import { useGlobal } from '@/utils/useGlobal';

const ICON = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M73.3332 39.9998C73.3332 58.4093 58.4093 73.3332 39.9998 73.3332C21.5903 73.3332 6.6665 58.4093 6.6665 39.9998C6.6665 21.5903 21.5903 6.6665 39.9998 6.6665C58.4093 6.6665 73.3332 21.5903 73.3332 39.9998ZM53.1233 27.8452C53.7741 27.1943 54.8294 27.1943 55.4803 27.8452L57.8373 30.2022C58.4882 30.8531 58.4882 31.9083 57.8373 32.5592L36.6241 53.7724C36.4432 53.9534 36.231 54.084 36.0049 54.1643L35.9387 54.2305C35.2879 54.8814 34.2326 54.8814 33.5817 54.2305L21.178 41.8268C20.5271 41.1759 20.5271 40.1206 21.178 39.4697L23.535 37.1127C24.1859 36.4618 25.2411 36.4618 25.892 37.1127L34.8739 46.0946L53.1233 27.8452Z"
            fill="#30BF00"
        />
    </svg>
);

export default function Success() {
    const { useLang } = useGlobal();
    const { locale = 'us' } = useRouter();
    const { t } = useLang('supportcasecreate');

    return (
        <div className="success-content">
            <ICON />
            <p className="title">{t('success_title')}</p>
            <p className="desc">
                {t.rich('success_desc', {
                    link: (text: string) => (
                        <EfLink
                            target="_blank"
                            className="link"
                            href={`/${locale}/my-assets-support`}
                            dataLayer={[
                                {
                                    event: 'uaEvent',
                                    event_name: 'my_support',
                                    // text 居然是数组
                                    button_name: text[0],
                                },
                            ]}
                        >
                            {text}
                        </EfLink>
                    ),
                })}
            </p>
            <p className="tips">{t('success_tips')}</p>
        </div>
    );
}
